export const whiteListedStorageKeys = [
  'returningPVLUser'
];

export const addSessionStorageParams = (search) => {
  const urlParams = new URLSearchParams(search);
  urlParams.forEach((value, key) => {
    if(whiteListedStorageKeys.includes(key) && !doesSessionStorageItemExist(key)) {
      setSessionStorageItem(key, value);
    }
  });
};

export const doesSessionStorageItemExist = (name) => {
  return sessionStorage.getItem(name) !== null;
};

export const getSessionStorageItem = (name) => {
  const value = sessionStorage.getItem(name);
  if(!value) {
    return '';
  }

  return value;
};

export const setSessionStorageItem = (key, value) => {
  if(key && value) {
    sessionStorage.setItem(key, value);
  }
};

export const removeSessionStorageItem = (name) => {
  sessionStorage.removeItem(name);
};
